import { render, staticRenderFns } from "./departCascader.vue?vue&type=template&id=60e7214a"
import script from "./departCascader.vue?vue&type=script&lang=js"
export * from "./departCascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports